import controller from './oo-admin-card-read.controller';
import template from './oo-admin-card-read.html';

export default {
	template,
	bindings: {
		link: '<',
	},
	controller,
	controllerAs: '$ctrl',
};
